import { Box } from '@locus-taxy/encore-mui';
import type { ReactNode } from 'react';

interface RouteWrapperProps {
  children: ReactNode;
}

export default function RouteWrapper({
  children,
}: Readonly<RouteWrapperProps>) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1, // Take remaining space in main content
        minHeight: 0, // Critical: allows flex child to shrink below content size
        height: '100%',
        overflow: 'hidden', // Prevent overflow
      }}
    >
      {children}
    </Box>
  );
}
